import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivate } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root'
})
export class MenuGuard implements CanActivate {

  constructor(
    private router: Router,
    private userService: UserService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
    const requiredMenu: string = route.data['menuName'];
    const authData = localStorage.getItem('auth');

    if (!authData) {
      this.router.navigate(['/login']);
      return false;
    }

    try {
      const parsedData = JSON.parse(authData);
      const userId = parsedData?.user?.id;

      if (!userId) {
        this.router.navigate(['/login']);
        return false;
      }

      return this.userService.getUserMenuTree(userId).pipe(
        map((menus: any[]) => {
          const hasAccess = this.recursiveMenuCheck(menus, requiredMenu);
          if (!hasAccess) {
            this.router.navigate(['/unauthorized']);
          }
          return hasAccess;
        }),
        catchError((err) => {
          console.error('Error fetching menu tree:', err);
          this.router.navigate(['/login']);
          return of(false);
        })
      );
    } catch (error) {
      console.error('Error parsing auth data:', error);
      this.router.navigate(['/login']);
      return false;
    }
  }

  private recursiveMenuCheck(menus: any[], target: string): boolean {
    if (!Array.isArray(menus)) return false;

    for (const menu of menus) {
      if (menu.name === target) {
        return true;
      }
      if (Array.isArray(menu.subMenu) && this.recursiveMenuCheck(menu.subMenu, target)) {
        return true;
      }
    }

    return false;
  }
}
